import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { guidFor } from '@ember/object/internals';

export default class ExpandToPopup extends Component {
  @tracked isOpen = false;
  @tracked showExpand = false;

  // uniqueId replaces the classic component's auto-assigned `elementId`,
  // which <PaperDialog @origin={{...}}> needs as a DOM id string.
  uniqueId = guidFor(this);

  get isSameDescription() {
    let educator = (this.args.goal?.educatorDescription || '')
      .toLowerCase()
      .replace(/\./g, '')
      .trim();
    let people = (this.args.goal?.peopleDescription || '')
      .toLowerCase()
      .replace(/\./g, '')
      .trim();

    return educator === people;
  }

  // checkSize re-checks whether the expand button's text is clamped
  // (scrollHeight > clientHeight). Runs once on insert and again on every
  // subsequent resize of the button itself, via {{did-resize}}.
  checkSize = (entry) => {
    let element = entry.target;
    let shouldExpand = element.scrollHeight > element.clientHeight;
    if (this.showExpand !== shouldExpand) {
      this.showExpand = shouldExpand;
    }
  };
}
